import React from 'react';
import './Antrag.css';


interface WorkExperienceDataFormProps {
    formData: {
        startDate: string | null;
        endDate: string | null;
        companyName: string | null;
        country: string | null;
        city: string | null;
        description: string | null;
    };
    countries: string[];
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    index: number;
    isViewOnly: boolean;
    showValidation: boolean;
}


const WorkExperienceDataForm: React.FC<WorkExperienceDataFormProps> = ({ formData, handleChange, countries, index, isViewOnly, showValidation }) => {
    return (
        <div>
            <div className='antrag-ausbildung'>
                <div>
                    <h5>
                        Berufserfahrung ({index + 1})
                    </h5>
                </div>
                <div>

                    <div className='form-group-ausbildung'>
                        <label className='form-label'>
                            Name des Arbeitgebers
                        </label>
                        <input
                            tabIndex={isViewOnly ? -1 : 0}
                            type='text'
                            className={`${showValidation && !formData.companyName ? 'error' : ''}`}
                            name='companyName'
                            maxLength={50}
                            value={formData.companyName ?? ''}
                            onChange={handleChange} />
                    </div>
                    <div className='form-group-ausbildung'>
                        <label className='form-label'>
                            Stadt
                        </label>
                        <input
                            tabIndex={isViewOnly ? -1 : 0}
                            type='text'
                            className={`${showValidation && !formData.city ? 'error' : ''}`}
                            name='city'
                            maxLength={50}
                            value={formData.city ?? ''}
                            onChange={handleChange} />
                    </div>
                    <div className='form-group-ausbildung'>
                        <label className='form-label'>Land</label>
                        <select
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`form-control form-select${showValidation && !formData.country ? ' error' : ''}`}
                            style={{ height: '46px' }}
                            title='Wählen Sie das Land des Arbeitgebers aus'
                            name='country'
                            value={formData.country ?? ''}
                            onChange={handleChange}
                        >
                            <option value="" disabled>Bitte auswählen</option>
                            {countries.map((country, index) => (
                                <option key={index} value={country}>
                                    {country}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div>
                    <div className='form-group-ausbildung'>
                        <label className='form-label'>
                            Beginn Arbeitsverhältnis
                        </label>
                        <input
                            tabIndex={isViewOnly ? -1 : 0}
                            type='month'
                            className={`${showValidation && !formData.startDate ? 'error' : ''}`}
                            name='startDate'
                            value={formData.startDate ?? ''}
                            onChange={handleChange} />
                    </div>
                    <div className='form-group-ausbildung'>
                        <label className='form-label'>
                            Ende Arbeitsverhältnis
                        </label>
                        <input
                            tabIndex={isViewOnly ? -1 : 0}
                            type='month'
                            className={`${showValidation && !formData.endDate ? 'error' : ''}`}
                            name='endDate'
                            value={formData.endDate ?? ''}
                            onChange={handleChange} />
                    </div>

                    <div className='form-group-ausbildung'>
                        <label className='form-label'>
                            Stellenbeschreibung
                        </label>
                        <textarea
                            tabIndex={isViewOnly ? -1 : 0}
                            className={`input-field ${showValidation && !formData.description ? 'error' : ''}`}
                            name='description'
                            maxLength={200}
                            placeholder='Beschreiben Sie Ihre Tätigkeit'
                            rows={5}
                            value={formData.description ?? ''}
                            onChange={handleChange}
                        >
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WorkExperienceDataForm;